import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';

const CONSENT_KEY = 'ihe_cookie_consent';
const SKIMLINKS_SRC = 'https://s.skimresources.com/js/310056X1798438.skimlinks.js';

const loadTrackingScripts = () => {
  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', {
      analytics_storage: 'granted',
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
    });
  }
  if (document.querySelector(`script[src="${SKIMLINKS_SRC}"]`)) return;
  const s = document.createElement('script');
  s.type = 'text/javascript';
  s.src = SKIMLINKS_SRC;
  s.async = true;
  document.body.appendChild(s);
};

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (consent === 'accepted') loadTrackingScripts();
    else if (!consent) setVisible(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem(CONSENT_KEY, value);
    if (value === 'accepted') loadTrackingScripts();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-consent-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[60] bg-primary text-white rounded-xl shadow-2xl border border-white/10 p-5 animate-in slide-in-from-bottom-4 fade-in duration-300"
    >
      <div className="flex gap-3">
        <Cookie className="h-6 w-6 text-[hsl(var(--gold))] flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <h3 className="font-semibold text-base mb-1">We value your privacy</h3>
          <p className="text-sm text-white/75 leading-relaxed">
            We use cookies to analyse traffic and to support affiliate links that help keep our content free.
            You can accept or decline non-essential cookies.{' '}
            <Link to="/privacy" className="underline text-[hsl(var(--gold))] hover:text-white transition-colors" data-testid="cookie-learn-more-link">
              Learn more
            </Link>
          </p>
          <div className="flex gap-3 mt-4">
            <button
              onClick={() => decide('accepted')}
              data-testid="cookie-accept-button"
              className="px-4 py-2 rounded-full bg-[hsl(var(--gold))] text-primary text-sm font-semibold hover:brightness-110 transition-[filter,transform] active:scale-95"
            >
              Accept
            </button>
            <button
              onClick={() => decide('declined')}
              data-testid="cookie-decline-button"
              className="px-4 py-2 rounded-full border border-white/30 text-sm font-medium text-white/90 hover:bg-white/10 transition-colors"
            >
              Decline
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
